import React, { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import Layout from "@/components/layout/Layout";
import { api, shortAddr, timeAgo, formatNumber } from "@/lib/api";
import { Button } from "@/components/ui/button";

export default function Blocks() {
  const [items, setItems] = useState([]);
  const [total, setTotal] = useState(0);
  const [params, setParams] = useSearchParams();
  const page = Math.max(1, Number(params.get("page") || 1));
  const perPage = 25;

  useEffect(() => {
    api.get(`/blocks`, { params: { limit: perPage, skip: (page - 1) * perPage } })
      .then((r) => { setItems(r.data.items); setTotal(r.data.total); });
  }, [page]);

  const totalPages = Math.max(1, Math.ceil(total / perPage));

  return (
    <Layout>
      <div className="mb-4">
        <h1 className="text-xl font-semibold">Blocks</h1>
        <p className="text-sm text-[var(--ks-text-soft)]">Total {formatNumber(total)} blocks on Etherscan.</p>
      </div>
      <div className="ks-card overflow-hidden">
        <div className="overflow-x-auto">
          <table className="ks-table" data-testid="blocks-table">
            <thead>
              <tr>
                <th>Block</th>
                <th>Age</th>
                <th>Txns</th>
                <th>Validator</th>
                <th>Gas Used</th>
                <th className="text-right">Reward</th>
              </tr>
            </thead>
            <tbody>
              {items.map((b) => (
                <tr key={b.number} data-testid={`blocks-row-${b.number}`}>
                  <td><Link to={`/block/${b.number}`} className="ks-link font-semibold">{formatNumber(b.number)}</Link></td>
                  <td>{timeAgo(b.timestamp)}</td>
                  <td>{b.tx_count}</td>
                  <td><Link to={`/address/${b.miner}`} className="ks-link mono">{shortAddr(b.miner)}</Link></td>
                  <td>{formatNumber(b.gas_used)} <span className="text-xs text-[var(--ks-text-soft)]">({((b.gas_used / b.gas_limit) * 100).toFixed(1)}%)</span></td>
                  <td className="text-right">{b.reward_eth} ETH</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <div className="flex items-center justify-between px-4 py-3 border-t border-[var(--ks-border)] text-sm">
          <span className="text-[var(--ks-text-soft)]">Page {page} of {totalPages}</span>
          <div className="flex gap-2">
            <Button variant="outline" size="sm" disabled={page <= 1} onClick={() => setParams({ page: page - 1 })} data-testid="blocks-prev">Prev</Button>
            <Button variant="outline" size="sm" disabled={page >= totalPages} onClick={() => setParams({ page: page + 1 })} data-testid="blocks-next">Next</Button>
          </div>
        </div>
      </div>
    </Layout>
  );
}
